import React from 'react';
import { Box, Container, List, ListItem, ListItemText, Paper, Typography } from '@mui/material';
import { TopBarContext } from '../TopBar';

interface ReportLink {
  title: string;
  url: string;
}

const reports: ReportLink[] = [
  {
    title: 'Consumo antibiotici in Regione Piemonte',
    url: 'https://www.regione.piemonte.it/web/media/44757/download',
  },
  {
    title: 'AMR in Regione Piemonte - 1',
    url: 'https://www.regione.piemonte.it/web/media/42927/download',
  },
  {
    title: 'AMR in Regione Piemonte - 2',
    url: 'https://www.regione.piemonte.it/web/media/42928/download',
  },
];

function Report() {
  const topBarCtx = React.useContext(TopBarContext);

  React.useEffect(() => {
    topBarCtx?.setTitle('Report');
  }, []);

  return (
    <Container maxWidth="md">
      <Box sx={{ my: 2 }}>
        <Typography variant="h5" component="h1" sx={{ mb: 2 }}>
          Report
        </Typography>
        <Paper elevation={1}>
          <List>
            {reports.map((report) => (
              <ListItem
                key={report.url}
                component="a"
                href={report.url}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: 'primary.main',
                  '&:hover': { backgroundColor: 'action.hover' },
                }}
              >
                <ListItemText primary={report.title} />
              </ListItem>
            ))}
          </List>
        </Paper>
      </Box>
    </Container>
  );
}

export default Report;
